export default {"src":"/_next/static/media/arrowUpDark.c232c04b.svg","height":9,"width":9,"blurWidth":0,"blurHeight":0};